import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DxDataGrid, {
    DxColumn,
    DxFilterRow,
    DxStateStoring,
    DxPaging,
    DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { UserProjectShowItem } from "@/services/entities/UserProjectItem";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProjectTable',
  props: {
    projects: { Type: [] as UserProjectShowItem[], default: [] as UserProjectShowItem[] },
},
  emits: ["detail"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxDataGrid), {
    "hover-state-enabled": true,
    "show-borders": false,
    "data-source": props.projects,
    id: "userProjectGridContainer",
    "auto-navigate-to-focused-row": false
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DxFilterRow), { visible: true }),
      _createVNode(_unref(DxStateStoring), {
        enabled: true,
        type: "localStorage",
        "storage-key": "userProjectGridContainer"
      }),
      _createVNode(_unref(DxHeaderFilter), { visible: true }),
      _createVNode(_unref(DxColumn), {
        "data-field": "project.projectName",
        "data-type": "string",
        caption: "Project name"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "project.projectNumber",
        "data-type": "string",
        caption: "Project number"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "project.service.blServiceName",
        "data-type": "string",
        caption: "Service"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "project.projectType",
        "data-type": "string",
        caption: "Project type"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "participationFrom",
        "data-type": "date",
        caption: "From",
        format: "dd/MM/yyyy"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "participationTo",
        "data-type": "date",
        caption: "To",
        format: "dd/MM/yyyy"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "project.isActive",
        "data-type": "boolean",
        caption: "Active",
        "allow-header-filtering": false,
        "allow-filtering": true
      }),
      _createVNode(_unref(DxPaging), { "page-size": 10 })
    ]),
    _: 1
  }, 8, ["data-source"]))
}
}

})